// Vellum - aparicion progresiva al entrar en pantalla
(() => {
  const SEL = '.v-reveal';
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SEL).forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const scan = (root = document) => root.querySelectorAll(SEL).forEach((el) => {
    if (!el.classList.contains('is-in')) io.observe(el);
  });

  scan();
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  // el editor de temas re-renderiza secciones: volvemos a escanear
  document.addEventListener('shopify:block:select', () => scan());
})();
